import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Sidebar from '../../components/ui/Sidebar';
import BreadcrumbNavigation from '../../components/ui/BreadcrumbNavigation';
import ProviderContextSwitcher from '../../components/ui/ProviderContextSwitcher';
import CalendarHeader from './components/CalendarHeader';
import EmployeeSelector from './components/EmployeeSelector';
import CalendarGrid from './components/CalendarGrid';
import AvailabilityLegend from './components/AvailabilityLegend';
import TimeSlotModal from './components/TimeSlotModal';
import BulkSchedulingPanel from './components/BulkSchedulingPanel';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import { useProviderStore } from 'Store/ProviderStore';

const AvailabilityCalendar = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const provider = useProviderStore((state) => state.provider);

  const [selectedProvider, setSelectedProvider] = useState(); // real salonId
  const [viewMode, setViewMode] = useState('week');
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [timeSlotModal, setTimeSlotModal] = useState({
    isOpen: false,
    timeSlot: null,
  });
  const [conflictWarnings, setConflictWarnings] = useState([]);

  // Mock conflict detection
  useEffect(() => {
    const mockConflicts = [{}];
    setConflictWarnings(mockConflicts);
  }, [selectedEmployees]);

  const handleSidebarToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleProviderChange = (providerValue) => {
    setSelectedProvider(providerValue);
  };

  const handleViewModeChange = (mode) => {
    setViewMode(mode);
  };

  const handlePreviousMonth = () => {
    const newDate = new Date(currentDate);
    newDate?.setMonth(newDate?.getMonth() - 1);
    setCurrentDate(newDate);
  };

  const handleNextMonth = () => {
    const newDate = new Date(currentDate);
    newDate?.setMonth(newDate?.getMonth() + 1);
    setCurrentDate(newDate);
  };

  const handleToday = () => {
    setCurrentDate(new Date());
  };

  const handleEmployeeChange = (employees) => {
    setSelectedEmployees(employees);
  };

  const handleSelectAllEmployees = () => {
    setSelectedEmployees([1, 2, 3, 4, 5]);
  };

  const handleClearAllEmployees = () => {
    setSelectedEmployees([]);
  };

  const handleTimeSlotClick = (timeSlotData) => {
    setTimeSlotModal({
      isOpen: true,
      timeSlot: timeSlotData,
    });
  };

  const handleTimeSlotSave = (formData) => {
    console.log('Saving time slot:', formData);
    // Here you would typically make an API call to save the data

    // Show success message
    alert('تغییرات با موفقیت ذخیره شد');
  };

  const handleBulkUpdate = (bulkData) => {
    console.log('Applying bulk update:', bulkData);
    // Here you would typically make an API call to apply bulk changes

    // Show success message
    alert(`تغییرات گروهی برای ${selectedEmployees?.length} کارمند اعمال شد`);
  };

  const handleExportSchedule = () => {
    // Mock export functionality
    alert('برنامه زمان‌بندی در حال دانلود است...');
  };

  const handlePrintSchedule = () => {
    window.print();
  };

  return (
    <div className="min-h-screen bg-background" dir="rtl">
      <Helmet>
        <title>تقویم دسترسی - پنل مدیریت خدمات دهنده</title>
        <meta
          name="description"
          content="مدیریت برنامه زمان‌بندی و دسترسی کارمندان خدمات دهنده با تقویم جلالی"
        />
      </Helmet>
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      {/* <Header
        isCollapsed={!sidebarOpen}
        onToggleSidebar={handleSidebarToggle}
      /> */}
      <main className="lg:mr-60 pt-16 min-h-screen">
        <div className="p-6 space-y-6">
          {/* Page Header */}
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
            <div>
              <BreadcrumbNavigation />
              <div className="mt-2">
                <h1 className="text-2xl font-bold text-foreground flex items-center gap-3">
                  <Icon name="Calendar" size={28} className="text-primary" />
                  تقویم دسترسی
                </h1>
                <p className="text-muted-foreground mt-1">
                  مدیریت برنامه زمان‌بندی و دسترسی کارمندان
                </p>
              </div>
            </div>

            {/* <div className="flex items-center gap-3">
              <Button
                variant="outline"
                size="sm"
                onClick={handleExportSchedule}
                iconName="Download"
                iconPosition="right">
                دانلود برنامه
              </Button>
              <Button
                variant="outline"
                size="sm"
                onClick={handlePrintSchedule}
                iconName="Printer"
                iconPosition="right">
                چاپ
              </Button>
            </div> */}
          </div>

          {/* Salon Context Switcher */}
          {/* <SalonContextSwitcher
            selectedSalon={selectedSalon}
            onSalonChange={handleSalonChange}
          /> */}

          {/* Conflict Warnings
          {conflictWarnings?.length > 0 && (
            <div className="bg-warning/10 border border-warning/20 rounded-lg p-4">
              <div className="flex items-start gap-3">
                <Icon
                  name="AlertTriangle"
                  size={20}
                  className="text-warning flex-shrink-0 mt-0.5"
                />
                <div className="flex-1">
                  <h3 className="text-sm font-semibold text-warning mb-2">
                    هشدار تداخل زمان‌بندی
                  </h3>
                  <div className="space-y-1">
                    {conflictWarnings?.map((warning) => (
                      <p key={warning?.id} className="text-sm text-warning/80">
                        {warning?.employee} - {warning?.date} ساعت{' '}
                        {warning?.time}: {warning?.message}
                      </p>
                    ))}
                  </div>
                </div>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => setConflictWarnings([])}
                  iconName="X"
                  iconSize={16}>
                  <span className="sr-only">بستن هشدار</span>
                </Button>
              </div>
            </div>
          )}*/}

          {/* Controls */}
          <div className="flex flex-col lg:flex-row gap-4">
            <div className="flex-1">
              <EmployeeSelector
                selectedEmployees={selectedEmployees}
                onEmployeeChange={handleEmployeeChange}
                onSelectAll={handleSelectAllEmployees}
                onClearAll={handleClearAllEmployees}
              />
            </div>
          </div>

          {/* Calendar Header */}
          <CalendarHeader
            currentDate={currentDate}
            viewMode={viewMode}
            onViewModeChange={handleViewModeChange}
            onPreviousMonth={handlePreviousMonth}
            onNextMonth={handleNextMonth}
            onToday={handleToday}
          />

          {/* Main Calendar Grid */}
          <CalendarGrid
            viewMode={viewMode}
            selectedEmployees={selectedEmployees}
            currentDate={currentDate}
            onTimeSlotClick={handleTimeSlotClick}
          />

          {/* Legend */}
          <AvailabilityLegend />

          {/* Bulk Scheduling Panel */}
          <BulkSchedulingPanel
            selectedEmployees={selectedEmployees}
            onBulkUpdate={handleBulkUpdate}
          />

          {/* Quick Stats */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="bg-card border border-border rounded-lg p-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-success/20 rounded-lg flex items-center justify-center">
                  <Icon name="Check" size={20} className="text-success" />
                </div>
                <div>
                  <p className="text-sm text-muted-foreground">
                    ساعات در دسترس
                  </p>
                  <p className="text-lg font-semibold text-foreground">۱۲۴</p>
                </div>
              </div>
            </div>

            <div className="bg-card border border-border rounded-lg p-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-error/20 rounded-lg flex items-center justify-center">
                  <Icon name="X" size={20} className="text-error" />
                </div>
                <div>
                  <p className="text-sm text-muted-foreground">
                    ساعات رزرو شده
                  </p>
                  <p className="text-lg font-semibold text-foreground">۸۶</p>
                </div>
              </div>
            </div>

            <div className="bg-card border border-border rounded-lg p-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-primary/20 rounded-lg flex items-center justify-center">
                  <Icon name="Users" size={20} className="text-primary" />
                </div>
                <div>
                  <p className="text-sm text-muted-foreground">کارمندان فعال</p>
                  <p className="text-lg font-semibold text-foreground">
                    {selectedEmployees?.length}
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-card border border-border rounded-lg p-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-warning/20 rounded-lg flex items-center justify-center">
                  <Icon
                    name="AlertTriangle"
                    size={20}
                    className="text-warning"
                  />
                </div>
                <div>
                  <p className="text-sm text-muted-foreground">
                    تداخل‌های زمانی
                  </p>
                  <p className="text-lg font-semibold text-foreground">
                    {conflictWarnings?.length}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      {/* Time Slot Modal */}
      <TimeSlotModal
        isOpen={timeSlotModal?.isOpen}
        onClose={() => setTimeSlotModal({ isOpen: false, timeSlot: null })}
        timeSlot={timeSlotModal?.timeSlot}
        onSave={handleTimeSlotSave}
      />
    </div>
  );
};

export default AvailabilityCalendar;
